import { useState } from "react";
import { NavLink } from "react-router-dom";
import "./DesktopDropdown.css";
import blockchain from "../../assets/images/header/blockchain.png";
import development from "../../assets/images/header/development.png";
import AI from "../../assets/images/header/artificialintelligence.png";
import machinelearning from "../../assets/images/header/machinelearning.png";
// import token from "../../assets/images/header/token.png";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const DesktopDropdown = () => {
  const [activeMenu, setActiveMenu] = useState("blockchain");
  const [activeSub, setActiveSub] = useState("blockchain");

  return (
    <div className="megamenu-container">
      <div className="row g-0">
        {/* LEFT COLUMN */}
        <div className="col-lg-3">
          <ul className="list-unstyled pe-2">
            <li
              className={`mega-item ${
                activeMenu === "blockchain" ? "active" : ""
              }`}
              onMouseEnter={() => setActiveMenu("blockchain")}
            >
              <div className="dropdown-item">
                <span>
                  <img
                    src={blockchain}
                    alt="img not found"
                    style={{ width: "30px", height: "30px", padding: "2px" }}
                  />
                </span>{" "}
                Blockchain{" "}
                <span className="arrow">
                  <KeyboardArrowRightIcon />
                </span>
              </div>
            </li>

            <li
              className={`mega-item ${
                activeMenu === "generativeai" ? "active" : ""
              }`}
              onMouseEnter={() => setActiveMenu("generativeai")}
            >
              <div className="dropdown-item">
                <span>
                  <img
                    src={AI}
                    alt="img not found"
                    style={{ width: "30px", height: "30px", padding: "2px" }}
                  />
                </span>{" "}
                Generative AI{" "}
                <span className="arrow">
                  <KeyboardArrowRightIcon />
                </span>
              </div>
            </li>

            <li
              className={`mega-item ${
                activeMenu === "software" ? "active" : ""
              }`}
              onMouseEnter={() => setActiveMenu("software")}
            >
              <div className="dropdown-item">
                <span>
                  <img
                    src={development}
                    alt="img not found"
                    style={{ width: "30px", height: "30px", padding: "2px" }}
                  />
                </span>{" "}
                Software Development{" "}
                <span className="arrow">
                  <KeyboardArrowRightIcon />
                </span>
              </div>
            </li>

            <li
              className={`mega-item ${activeMenu === "ai" ? "active" : ""}`}
              onMouseEnter={() => setActiveMenu("ai")}
            >
              <div className="dropdown-item">
                <span>
                  <img
                    src={machinelearning}
                    alt="img not found"
                    style={{ width: "30px", height: "30px", padding: "2px" }}
                  />
                </span>{" "}
                AI & ML{" "}
                <span className="arrow">
                  <KeyboardArrowRightIcon />
                </span>
              </div>
            </li>

            {/* <li
              className={`mega-item ${activeMenu === "token" ? "active" : ""}`}
              onMouseEnter={() => setActiveMenu("token")}
            >
              <div className="dropdown-item">
                <span>
                  <img
                    src={token}
                    alt="img not found"
                    style={{ width: "30px", height: "30px", padding: "2px" }}
                  />
                </span>{" "}
                Token{" "}
                <span className="arrow">
                  <KeyboardArrowRightIcon />
                </span>
              </div>
            </li> */}
          </ul>
        </div>

        {/* RIGHT COLUMN */}
        <div className="col-lg-9">
          {/* BLOCKCHAIN */}
          {activeMenu === "blockchain" && (
            <div className="mega-content">
              <div className="row g-0">
                <div className="col-lg-4">
                  <ul className="list-unstyled">
                    <li
                      className={`mega-item ${
                        activeSub === "blockchain" ? "active" : ""
                      }`}
                      onMouseEnter={() => setActiveSub("blockchain")}
                    >
                      <div className="dropdown-item">
                        Blockchain{" "}
                        <span className="arrow">
                          <KeyboardArrowRightIcon />
                        </span>
                      </div>
                    </li>
                    <li
                      className={`mega-item ${
                        activeSub === "crypto" ? "active" : ""
                      }`}
                      onMouseEnter={() => setActiveSub("crypto")}
                    >
                      <div className="dropdown-item">
                        Cryptocurrency{" "}
                        <span className="arrow">
                          <KeyboardArrowRightIcon />
                        </span>
                      </div>
                    </li>
                    <li
                      className={`mega-item ${
                        activeSub === "cryptoexchange" ? "active" : ""
                      }`}
                      onMouseEnter={() => setActiveSub("cryptoexchange")}
                    >
                      <div className="dropdown-item">
                        Crypto Exchange{" "}
                        <span className="arrow">
                          <KeyboardArrowRightIcon />
                        </span>
                      </div>
                    </li>
                    <li
                      className={`mega-item ${
                        activeSub === "nft" ? "active" : ""
                      }`}
                      onMouseEnter={() => setActiveSub("nft")}
                    >
                      <div className="dropdown-item">
                        NFT{" "}
                        <span className="arrow">
                          <KeyboardArrowRightIcon />
                        </span>
                      </div>
                    </li>
                    <li
                      className={`mega-item ${
                        activeSub === "web3" ? "active" : ""
                      }`}
                      onMouseEnter={() => setActiveSub("web3")}
                    >
                      <div className="dropdown-item">
                        Web3{" "}
                        <span className="arrow">
                          <KeyboardArrowRightIcon />
                        </span>
                      </div>
                    </li>
                    <li
                      className={`mega-item ${
                        activeSub === "meta" ? "active" : ""
                      }`}
                      onMouseEnter={() => setActiveSub("meta")}
                    >
                      <div className="dropdown-item">
                        Metaverse{" "}
                        <span className="arrow">
                          <KeyboardArrowRightIcon />
                        </span>
                      </div>
                    </li>
                    <li
                      className={`mega-item ${
                        activeSub === "industries" ? "active" : ""
                      }`}
                      onMouseEnter={() => setActiveSub("industries")}
                    >
                      <div className="dropdown-item">
                        Industries{" "}
                        <span className="arrow">
                          <KeyboardArrowRightIcon />
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="col-lg-8 ps-3" style={{ marginTop: "5px" }}>
                  <ul className="list-unstyled">
                    {activeSub === "blockchain" && (
                      <>
                        <li>
                          <NavLink
                            to="/service/blockchain-development"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            Blockchain Development
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/service/blockchain-consulting"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            Blockchain Consulting
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/service/ethereum-blockchain-development"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            Ethereum Blockchain Development
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/service/dapp-development"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            Dapp Development
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/service/smart-contract-development"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            Smart Contract Development
                          </NavLink>
                        </li>
                      </>
                    )}
                    {activeSub === "crypto" && (
                      <>
                        <li>
                          <NavLink
                            to="/service/cryptocurrency-development"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            Cryptocurrency Token Development
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/service/cryptowallet-development"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            Cryptocurrency Wallet Development
                          </NavLink>
                        </li>
                      </>
                    )}

                    {activeSub === "cryptoexchange" && (
                      <>
                        <li>
                          <NavLink
                            to="/service/cryptoexchange-development"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            Cryptocurrency Exchange Development
                          </NavLink>
                        </li>
                      </>
                    )}

                    {activeSub === "nft" && (
                      <>
                        <li>
                          <NavLink
                            to="/service/nft-marketplace"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            NFT Marketplace Development
                          </NavLink>
                        </li>
                        {/* <li>
                          <NavLink
                            to="/service/nft-token-development"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            NFT Minting Platform 
                          </NavLink>
                        </li> */}
                        {/* <li>
                          <NavLink to="">NFT Game Development</NavLink>
                        </li> */}
                        <li>
                          <NavLink
                            to="/service/white-label-nft"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            White Label NFT Marketplace
                          </NavLink>
                        </li>
                      </>
                    )}

                    {activeSub === "web3" && (
                      <>
                        <li>
                          <NavLink
                            to="/service/web3-dapp-development"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            Web3 Dapp Development
                          </NavLink>
                        </li>
                        {/* <li>
                          <NavLink
                            to="/service/web3game-development"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            DAO Development
                          </NavLink>
                        </li> */}
                        <li>
                          <NavLink
                            to="/service/web3-consulting-service"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            Web3 Consulting
                          </NavLink>
                        </li>
                      </>
                    )}

                    {activeSub === "meta" && (
                      <>
                        <li>
                          <NavLink
                            to="/service/metaverse-development"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            Metaverse Development
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/service/metaverse-game-development"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            Metaverse Games Development
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/service/playtoearn-game-development"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            P2E Game Development
                          </NavLink>
                        </li>
                      </>
                    )}

                    {activeSub === "industries" && (
                      <>
                        <li>
                          <NavLink
                            to="/service/logistics"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            Supplychain & Logistics
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/service/finance"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            Finance
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/service/insurance"
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                          >
                            Insurance
                          </NavLink>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          )}

          {/* AI Generative*/}
          {activeMenu === "generativeai" && (
            <div className="mega-content">
              <ul className="list-unstyled">
                <li>
                  <NavLink to="">Generative AI Development</NavLink>
                </li>
                <li>
                  <NavLink to="">Generative AI Consulting</NavLink>
                </li>
                <li>
                  <NavLink to="">Gen AI Integration Services</NavLink>
                </li>
                <li>
                  <NavLink to="">LLM Development</NavLink>
                </li>
                <li>
                  <NavLink to="">LLM Integration</NavLink>
                </li>
                <li>
                  <NavLink to="">AI Agents Development</NavLink>
                </li>
                <li>
                  <NavLink to="">MCP Development Company</NavLink>
                </li>
                <li>
                  <NavLink to="">Co-pilot Development</NavLink>
                </li>
              </ul>
            </div>
          )}

          {/* Software */}
          {activeMenu === "software" && (
            <div className="mega-content">
              <ul className="list-unstyled">
                <li>
                  <NavLink
                    to="/service/software-development"
                    className={({ isActive }) =>
                      isActive ? "dropdown-item active" : "dropdown-item"
                    }
                  >
                    Software Development
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/service/web-application"
                    className={({ isActive }) =>
                      isActive ? "dropdown-item active" : "dropdown-item"
                    }
                  >
                    Web Application Development
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/service/mobile-application"
                    className={({ isActive }) =>
                      isActive ? "dropdown-item active" : "dropdown-item"
                    }
                  >
                    Mobile App Development
                  </NavLink>
                </li>
              </ul>
            </div>
          )}

          {/* AI */}
          {activeMenu === "ai" && (
            <div className="mega-content">
              <ul className="list-unstyled">
                <li>
                  <NavLink to="">AI Development</NavLink>
                </li>
                <li>
                  <NavLink to="">AI App Development</NavLink>
                </li>
                <li>
                  <NavLink to="">AI Consulting</NavLink>
                </li>
                <li>
                  <NavLink to="">AI Software Development</NavLink>
                </li>
                <li>
                  <NavLink to="">ChatBot Development</NavLink>
                </li>
                <li>
                  <NavLink to="">Enterprise AI ChatBot</NavLink>
                </li>
                <li>
                  <NavLink to="">AI Chatbot Development</NavLink>
                </li>
                <li>
                  <NavLink to="">Machine Learning Development</NavLink>
                </li>
                <li>
                  <NavLink to="">AI Copilot Development</NavLink>
                </li>
                <li>
                  <NavLink to="">AI Agent Development</NavLink>
                </li>
                <li>
                  <NavLink to="">AI Deployment Services</NavLink>
                </li>
                <li>
                  <NavLink to="">AI Development Company</NavLink>
                </li>
              </ul>
            </div>
          )}

          {/* Token */}
          {/* {activeMenu === "token" && (
            <div className="mega-content">
              <ul className="list-unstyled">
                <li>
                  <NavLink to="">Ethereum Token Development</NavLink>
                </li>
                <li>
                  <NavLink to="">Tokenization Platform Development</NavLink>
                </li>
                <li>
                  <NavLink to="">Asset Tokenization</NavLink>
                </li>
              </ul>
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default DesktopDropdown;
